// Container
import store from '@/store';

const DefaultContainer = () => import('@/containers/DefaultContainer')

const InventoryPage = () => import('@/modules/inventory/views/InventoryPage')
const InventoryBoard = () => import('@/modules/inventory/views/InventoryBoard')
const InventorySettings = () => import('@/modules/inventory/views/InventorySettings')

var routes = [
	{
		path: '/inventory',
		redirect: '/inventory/board',
		name: 'Inventory',
		component: DefaultContainer,
		children: [
			{
				path: '/inventory',
				name: 'InventoryPage',
				redirect: '/inventory/board',
				component: InventoryPage,
				meta: {
					requiresAuth: true,
					permission: false,
				},
				children: [
					{
						path: 'board',
						name: 'InventoryBoard',
						component: InventoryBoard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'board',
						},
					},
					{
						path: 'settings',
						name: 'InventorySettings',
						component: InventorySettings,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'settings',
						},
						// Hiding the tab is not enough on its own: typing the URL would still
						// land on a 422 and a blank screen. Same rule as the tab and as the
						// API — super users bypass, everyone else needs the grant.
						beforeEnter: (to, from, next) => {
							var permissions = store.getters.getUserInfo('all_permissions') || []

							var allowed = store.getters.getUserInfo('super_user')
								|| permissions.some((perm) =>
									perm.section === 'manage_company' && perm.slug === 'manage_inventory')

							next(allowed ? undefined : { name: 'InventoryBoard' })
						},
					},
				]
			}
		]
	}
];

export default routes;
